import { JoinData } from './JoinDataInt';

const topButtonsHeight = 56;
const topButtonsY = 95;

const pinPadHeight = 85;
const pinPadWidth = 84;

const pinpad1Y = 225;
const pinpad2Y = 314;
const pinpad3Y = 403;
const pinpad1X = 556;
const pinpad2X = 645;
const pinpad3X = 734;

const category = "room_video_cable_keypad";

const roomVideoCableKeypad: JoinData[] = [
    { join: "digital-press-45", name: "Back", x: 133, y: 31, width: 53, height: 36, category },
    { join: "serial-feedback-2", name: "Room Name", x: 651, y: 23, width: 88, height: 32, category },

    { join: "digital-feedback-90", name: "Select Source Feedback", x: 959, y: 21, width: 177, height: 65, group: "video_source", category },
    { join: "digital-press-90", name: "Select Source", x: 959, y: 21, width: 177, height: 65, group: "video_source", category },
    { join: "serial-feedback-12", name: "Video Source Name", x: 969, y: 31, width: 159, height: 44, category },
    { join: "digital-press-122", name: "Video Power Off", x: 1225, y: 35, width: 30, height: 30, category },

    // { join: "svg_8", name: "Open Sharing Menu", x: 1211, y: 735, width: 45, height: 46, category },
    { join: "digital-feedback-91", name: "Video Mute Feedback", x: 587, y: 741, width: 39, height: 39, group: "video_mute", category },
    { join: "digital-press-91", name: "Video Mute", x: 587, y: 741, width: 39, height: 39, group: "video_mute", category },
    { join: "digital-press-95", name: "Video Volume Down", x: 644, y: 741, width: 39, height: 39, category },
    { join: "analog-feedback-1", name: "Current Volume", x: 707, y: 745, width: 25, height: 30, category },
    { join: "digital-press-94", name: "Video Volume Up", x: 753, y: 741, width: 39, height: 39, category },

    { join: "digital-feedback-10", name: "Display Toggle Visibility", x: 1144, y: 23, width: 75, height: 51, category },
    { join: "digital-feedback-9", name: "Display Toggle Feedback", x: 1176, y: 35, width: 43, height: 30, group: 'display_toggle', category },
    { join: "digital-press-9", name: "Display Toggle Press", x: 1176, y: 35, width: 43, height: 30, group: 'display_toggle', category },

    { join: "digital-feedback-294", name: "Remote Visibility", x: 510, y: topButtonsY, width: 103, height: topButtonsHeight, group: 'remote', category },
    { join: "digital-press-290", name: "Remote Press", x: 510, y: topButtonsY, width: 103, height: topButtonsHeight, group: 'remote', category },
    { join: "digital-feedback-295", name: "Keypad Visibility", x: 617, y: topButtonsY, width: 80, height: topButtonsHeight, group: 'keypad', category },
    { join: "digital-press-291", name: "Keypad Press", x: 617, y: topButtonsY, width: 80, height: topButtonsHeight, group: 'keypad', category },
    { join: "digital-feedback-296", name: "DVR Visibility", x: 699, y: topButtonsY, width: 63, height: topButtonsHeight, group: 'dvr', category },
    { join: "digital-press-292", name: "DVR Press", x: 699, y: topButtonsY, width: 63, height: topButtonsHeight, group: 'dvr', category },
    { join: "digital-feedback-297", name: "Favorites Visibility", x: 765, y: topButtonsY, width: 109, height: topButtonsHeight, group: 'favorites', category },
    { join: "digital-press-293", name: "Favorites Press", x: 765, y: topButtonsY, width: 109, height: topButtonsHeight, group: 'favorites', category },

    { join: "digital-press-308", name: "Keypad 1", x: pinpad1X, y: pinpad1Y, width: pinPadWidth, height: pinPadHeight, category },
    { join: "digital-press-309", name: "Keypad 2", x: pinpad2X, y: pinpad1Y, width: pinPadWidth, height: pinPadHeight, category },
    { join: "digital-press-310", name: "Keypad 3", x: pinpad3X, y: pinpad1Y, width: pinPadWidth, height: pinPadHeight, category },
    { join: "digital-press-311", name: "Keypad 4", x: pinpad1X, y: pinpad2Y, width: pinPadWidth, height: pinPadHeight, category },
    { join: "digital-press-312", name: "Keypad 5", x: pinpad2X, y: pinpad2Y, width: pinPadWidth, height: pinPadHeight, category },
    { join: "digital-press-313", name: "Keypad 6", x: pinpad3X, y: pinpad2Y, width: pinPadWidth, height: pinPadHeight, category },
    { join: "digital-press-314", name: "Keypad 7", x: pinpad1X, y: pinpad3Y, width: pinPadWidth, height: pinPadHeight - 1, category },
    { join: "digital-press-315", name: "Keypad 8", x: pinpad2X, y: pinpad3Y, width: pinPadWidth, height: pinPadHeight - 1, category },
    { join: "digital-press-316", name: "Keypad 9", x: pinpad3X, y: pinpad3Y, width: pinPadWidth, height: pinPadHeight - 1, category },
    { join: "digital-press-307", name: "Keypad 0", x: pinpad1X, y: 491, width: 262, height: pinPadHeight - 1, category },
];

export default roomVideoCableKeypad;
